// extracted by mini-css-extract-plugin
export default {"button":"styles_button__GamVx","active":"styles_active__9fA8t"};